module.exports = __webpack_public_path__ + "assets/images/profiles/2020-main-2.jpg?v=61c241c7";